import type {UpdateLog} from 'services/metadata/types';

export const findFirstOfEachStatus = (
  logs: UpdateLog[],
): Record<'NEW' | 'PRE_CATALOGED' | 'CONTROL' | 'COMPLETED', UpdateLog> => {
  const statusMap: Record<string, UpdateLog> = {};

  logs.forEach(log => {
    if (log.statusChanged && !statusMap[log.statusChanged]) {
      statusMap[log.statusChanged] = log;
    }
  });

  return statusMap;
};
